import React, {useState, useCallback} from 'react';
import {Box, useTheme} from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import {useTranslation} from 'react-i18next';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RegistrationDetails from './registration-details';
import {AccessCode} from '@/types/company';

interface RegistrationDetailsHiderProps {
  registerLink: string;
  accessCodes: AccessCode[] | undefined;
}

const RegistrationDetailsHider: React.FC<RegistrationDetailsHiderProps> = ({
  registerLink,
  accessCodes
}) => {
  const {t} = useTranslation();

  const theme = useTheme();

  const [showRegistationDetails, setShowRegistationDetails] = useState(false);

  const handleShowRegistationDetails = useCallback(() => {
    setShowRegistationDetails(true);
  }, []);

  const handleHideRegistationDetails = useCallback(() => {
    setShowRegistationDetails(false);
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="center"
      alignItems="center"
      marginTop={2}
    >
      {!showRegistationDetails ? (
        <ResponsiveTypography
          onClick={handleShowRegistationDetails}
          sx={{
            cursor: 'pointer',
            padding: '4px 8px',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: theme.palette.primary.light,
              borderRadius: '5px',
              transition: 'background-color 0.3s'
            }
          }}
        >
          {t('show_registration_details')}
          <ArrowDropDownIcon
            fontSize="small"
            style={{verticalAlign: 'middle', marginBottom: 4}}
          />
        </ResponsiveTypography>
      ) : (
        <>
          <ResponsiveTypography
            onClick={handleHideRegistationDetails}
            sx={{
              cursor: 'pointer',
              padding: '4px 8px',
              '&:hover': {
                backgroundColor: theme.palette.primary.light,
                borderRadius: '5px',
                transition: 'background-color 0.3s'
              }
            }}
          >
            {t('hide_registration_details')}
            <ArrowDropUpIcon
              fontSize="small"
              style={{verticalAlign: 'middle'}}
            />
          </ResponsiveTypography>
          <RegistrationDetails
            registerLink={registerLink}
            accessCodes={accessCodes}
          />
        </>
      )}
    </Box>
  );
};

export default RegistrationDetailsHider;
